import { Component, OnInit, OnDestroy } from '@angular/core';
import { of, Subscription } from 'rxjs';
import { RelationshipService } from '../../tamalelibs/services/relationship.service';
import { ToastService } from '../../widgets/toast/toast.service';
import { NotificationStyles } from '../../widgets/notification/notification.model';
import { NewRelationshipService } from './new-relationship-dialog.service';
import { RelationshipTypeService } from '../../tamalelibs/services/relationshipType.service';
import { catchError } from 'rxjs/operators';
import { Relationship } from '../../tamalelibs/models/relationship.model';
import { businessConstants } from '../../tamalelibs/constants/business.constants';

@Component({
    selector: 'new-relationship-dialog',
    templateUrl: './new-relationship-dialog.component.html',
    styleUrls: ['./new-relationship-dialog.component.scss']
})
export class NewRelationshipDialogComponent implements OnInit, OnDestroy {

    opened = false;
    dialogWidth = 480;
    relationshipTypes = [{ 'name': 'Contact to Entities', 'id': businessConstants.EntityTypes.Contact_Id }, { 'name': 'Contact to Contact', 'id': businessConstants.EntityTypes.Contact_To_Contact_Id }];
    relationshipType;
    inputRelationshipTypeName;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(
        private _newRelationshipService: NewRelationshipService,
        private _relationshipService: RelationshipService,
        private _relationshipTypeService: RelationshipTypeService,
        private _toast: ToastService,
    ) {
    }

    ngOnInit() {
        this._destroySubscriptions.push(
            this._newRelationshipService.dialogOpen$.subscribe(res => {
                if (res.relationshiTyeName) {
                    this.inputRelationshipTypeName = res.relationshiTyeName;
                }
                this.opened = true;
                this.relationshipType = this.relationshipTypes[0];
            }),
        );
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    selectionChange() { }

    onCancelBtnClick() {
        this.clickClose();
    }

    clickClose() {
        this.opened = false;
        this.relationshipType = '';
        this.inputRelationshipTypeName = '';
    }

    createRelationShip() {
        this._relationshipTypeService.createRelationshipType(this.inputRelationshipTypeName)
            .pipe(
                catchError((err) => {
                    this._toast.notify({
                        message: err,
                        style: NotificationStyles.Error
                    });
                    return of(null);
                }))
            .subscribe(response => {
                this._relationshipService.createValidRelationship(this.relationshipType.id, response['id'])
                    .pipe(
                        catchError((err) => {
                            this._toast.notify({
                                message: err,
                                style: NotificationStyles.Error
                            });
                            return of(null);
                            // tslint:disable-next-line: no-shadowed-variable
                        })).subscribe(response => {
                            this.clickClose();
                            this._toast.notify({
                                message: 'Valid Relationship ' + this.relationshipType.name + ' successfully created',
                                style: NotificationStyles.Success
                            });
                            const validRelationship = new Relationship();
                            validRelationship.relationshipId = response['id'];
                            validRelationship.relationshipType = response['name'];
                            this._newRelationshipService.feedbackSubject$.next(validRelationship);
                        });
            });
    }

}
